import { render } from "./laborOfflinePage.vue?vue&type=template&id=6160921e&scoped=true"
import script from "./laborOfflinePage.vue?vue&type=script&lang=js"
export * from "./laborOfflinePage.vue?vue&type=script&lang=js"

import "./laborOfflinePage.vue?vue&type=style&index=0&id=6160921e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6160921e"]])

export default __exports__